"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardSourceSchema = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Check_1 = __importDefault(require("@mui/icons-material/Check"));
const Error_1 = __importDefault(require("@mui/icons-material/Error"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lodash_1 = __importStar(require("lodash"));
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const validator_1 = __importDefault(require("validator"));
const zod_1 = require("zod");
const errorUtil_1 = require("../../../../../common/lib/errorUtil");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const companyQuery_1 = require("../../../../queries/companyQuery");
const currenciesQuery_1 = require("../../../../queries/currenciesQuery");
const paymentQuery_1 = require("../../../../queries/paymentQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const paymentRepository_1 = require("../../../../repositories/paymentRepository");
const zustandStore_1 = require("../../../../zustandStore");
const simpleHeader_1 = __importDefault(require("../../../organisms/header/simpleHeader"));
const cards_1 = __importDefault(require("../../../templates/companySettings/cards"));
const useCompanySetingsCardsState_1 = require("./hooks/useCompanySetingsCardsState");
const logger = (0, pino_1.default)();
const includeSelectTeams = true;
const includeRemoveCard = false;
const isSandOrProdEnv = globalThis.config.IS_PRODUCTION || globalThis.config.IS_SANDBOX;
const CardSourceSchema = (cardProvider) => {
    const isAmexCardProvider = cardProvider === 'AMEX';
    const isHsbcCardProvider = cardProvider === 'HSBC';
    return zod_1.z.object({
        email: zod_1.z
            .email({ error: strings_1.cardDetailStrings.INVALID_EMAIL_FORMAT })
            .refine((value) => {
            if (isAmexCardProvider) {
                return true;
            }
            if (validator_1.default.isEmail(value)) {
                return !value.includes('+');
            }
            return true;
        }, {
            message: strings_1.cardDetailStrings.INVALID_EMAIL_VALIDATION_BY_PROVIDER,
        })
            .optional(),
        cardNumber: zod_1.z
            .string()
            .refine(value => isSandOrProdEnv ? validator_1.default.isCreditCard(value, { provider: isAmexCardProvider ? 'amex' : 'visa' }) : true, {
            message: strings_1.cardDetailStrings.INVALID_CARD_NUMBER,
        })
            .optional(),
        zipCode: zod_1.z
            .string()
            .refine(value => validator_1.default.isPostalCode(value, isHsbcCardProvider ? 'GB' : 'US'), {
            error: strings_1.cardDetailStrings.INVALID_ENTRY_WARNING({ field: 'zipcode' }),
        })
            .optional(),
        id: zod_1.z.string().optional(),
        name: zod_1.z.string().optional(),
        city: zod_1.z
            .string()
            .refine(value => !/^\d+$/.test(value), {
            error: strings_1.cardDetailStrings.INVALID_ENTRY_WARNING({ field: 'city' }),
        })
            .optional(),
        regionCode: zod_1.z
            .string()
            .refine((value) => {
            if (isAmexCardProvider) {
                return Boolean(value);
            }
            if (isHsbcCardProvider) {
                if (value == null) {
                    return strings_1.cardDetailStrings.REGION_REQUIRED;
                }
                if (value.length < 2) {
                    return strings_1.cardDetailStrings.MIN_REGION_LENGTH;
                }
                if (value.length > 27) {
                    return strings_1.cardDetailStrings.MAX_REGION_LENGTH;
                }
                return true;
            }
            return true;
        }, {
            message: strings_1.cardDetailStrings.INVALID_REGION_FORMAT,
        })
            .optional(),
    });
};
exports.CardSourceSchema = CardSourceSchema;
function getInitialDialogState() {
    return { open: false, info: { type: '', message: '' } };
}
const CompanySettingsCardsPage = () => {
    const [dialog, setDialog] = (0, react_1.useState)(getInitialDialogState());
    const { setPageLoading } = (0, zustandStore_1.useZustand)();
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: userData } = (0, react_query_1.useQuery)({
        ...userQuery_1.userQuery,
        initialData: initialData.user,
    });
    const { data: teams } = (0, react_query_1.useQuery)({
        ...teamQuery_1.allTeamsQuery,
        initialData: initialData.teams,
    });
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)({
        ...(0, companyQuery_1.companyPropertiesQuery)(userData?.companyAccountId, { cardprovider: 'tsgo-cardprovider' }),
        initialData: initialData.companyProperties,
    });
    const { data: currencies } = (0, react_query_1.useQuery)((0, currenciesQuery_1.getCurrenciesQuery)(undefined));
    const billingCurrency = (currencies && currencies.length > 0 && currencies[0]) || 'N/A';
    const enrollWithAmexV2 = (0, paymentQuery_1.useEnrollCardV2Query)();
    const state = (0, useCompanySetingsCardsState_1.useCompanySetingsCardsState)();
    const addCardSourceToTeam = (0, paymentQuery_1.useAddCardSourceToTeamQuery)();
    const removeCardSourceFromTeam = (0, paymentQuery_1.useRemoveCardSourceFromTeamQuery)();
    const setCardName = (0, paymentQuery_1.useSetCardNameQuery)({ shouldSetOnCompanyCard: true });
    const { refetch: refetchGetCardSource } = (0, paymentQuery_1.useGetCardSourceQuery)({
        cardSourceId: state.cardSourceId || '',
        includeCardHolder: true,
    });
    const { refetch: refetchGetTeamsForCardSource } = (0, paymentQuery_1.useGetTeamsForCardSourceQuery)({
        cardSourceId: state.cardSourceId,
    });
    const handleOnSuccess = () => {
        state.setNotification([
            { type: strings_1.notificationStrings.SUCCESS, message: strings_1.cardDetailStrings.SELECT_TEAMS_SUBMIT_SUCCESS },
        ]);
    };
    const handleOnError = () => {
        state.setNotification([
            {
                type: strings_1.notificationStrings.WARNING,
                message: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                    ? strings_1.errorStrings.DEFAULT
                    : strings_1.cardDetailStrings.SELECT_TEAMS_SUBMIT_ERROR,
            },
        ]);
    };
    (0, react_1.useEffect)(() => {
        const timeoutId = setTimeout(() => {
            setDialog(getInitialDialogState());
        }, 3000);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [dialog.open]);
    (0, react_1.useEffect)(() => {
        if (state.cardSourceId) {
            void refetchGetCardSource();
            void refetchGetTeamsForCardSource();
        }
    }, [state.cardSourceId]);
    (0, react_1.useEffect)(() => {
        if (userData) {
            state.setUser(userData);
            state.setCompanyName(userData.companyName);
            state.setCompanyId(userData.companyAccountId);
            state.setHeaderName(userData.companyName);
        }
    }, [state.setUser, state.setCompanyName, state.setCompanyId, state.setHeaderName, userData]);
    (0, react_1.useEffect)(() => {
        void (async () => {
            if (state.aside.selectTeams.isOpen) {
                const selectedTeamIds = getSelectedTeamIds();
                const selectedTeamOptions = await getSelectTeamOptions();
                if (!selectedTeamOptions || !selectedTeamIds) {
                    return;
                }
                state.setIsSelectTeamsOpen({
                    model: { id: selectedTeamIds },
                    options: selectedTeamOptions,
                });
            }
        })();
    }, [state.aside.selectTeams.isOpen]);
    const submitCardSourceData = (0, react_1.useCallback)((formData) => {
        setPageLoading(true);
        const isFormValid = validate({ cardSource: formData, cardProvider: companyPropertiesData?.cardprovider || '' });
        if (!isFormValid) {
            setPageLoading(false);
            return;
        }
        enrollWithAmexV2.mutate({
            enrollData: { ...formData, billingCurrency },
            teamId: state.teamId,
            cardProvider: companyPropertiesData?.cardprovider || '',
        }, {
            onSuccess: () => {
                state.setNotification([
                    { type: strings_1.notificationStrings.SUCCESS, message: strings_1.messageStrings.CREDIT_CARD_SUCCESS_MESSAGE },
                ]);
            },
            onError: error => {
                if ((0, errorUtil_1.isCardsProviderError)(error)) {
                    state.setNotification([
                        {
                            type: strings_1.notificationStrings.WARNING,
                            message: strings_1.messageStrings.CARD_PROVIDER_WARNING_MESSAGE,
                        },
                    ]);
                }
                else {
                    state.setNotification([
                        {
                            type: strings_1.notificationStrings.WARNING,
                            message: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? strings_1.errorStrings.DEFAULT
                                : strings_1.messageStrings.CARD_WARNING_ERROR,
                        },
                    ]);
                }
            },
            onSettled: () => {
                state.setIsAddSourceCardOpen(false);
                setPageLoading(false);
            },
        });
    }, [billingCurrency, companyPropertiesData?.cardprovider, state.teamId, state.companyCardSources]);
    const getSelectedTeamIds = () => {
        if (!includeSelectTeams) {
            return [];
        }
        return state.cardSourceTeams?.filter(card => card.state === appConstants_1.userStatus.ACTIVE).map(card => card.id);
    };
    const getSelectTeamOptions = async () => {
        if (!includeSelectTeams) {
            return;
        }
        const activeTeams = teams.filter(team => team.state === appConstants_1.userStatus.ACTIVE) || [];
        const selectedTeamIds = getSelectedTeamIds();
        return await Promise.all(activeTeams.map(async (team) => {
            if (!selectedTeamIds?.find(selectedTeam => team.id === selectedTeam)) {
                return team;
            }
            const cardSourcesForTeam = await paymentRepository_1.PaymentRepository.getCardSources({ includeTeamCount: true, status: true }, team.id);
            return { ...team, disabled: cardSourcesForTeam?.data?.length <= 1 };
        }));
    };
    const toggleCardDetailsAside = (value, id = '') => {
        const cardSourceId = value ? state.cardSourceDetail.cardSourceId : '';
        state.setIsCardSourceDetailOpen({ isOpen: value, cardSourceId: id || cardSourceId });
    };
    const toggleAddCardSourceAside = (0, react_1.useCallback)(value => {
        state.setIsAddSourceCardOpen(value);
    }, []);
    /**
     * Currently, the method isn't being used,
     * therefore initializing numCards to 0
     * @param {*} type
     * @param {*} value
     */
    const toggleCard = (type, value) => {
        const numCards = 0;
        if (type === '' || type === null || type === undefined) {
            type = numCards > 1 ? appConstants_1.cardDetailsAsideProperties.REMOVE_CARD : appConstants_1.cardDetailsAsideProperties.CANT_REMOVE_CARD;
        }
        state.setOpenAsides({ type, isOpen: value });
    };
    const validate = ({ cardSource, cardProvider }) => {
        let errors = {};
        const cardSourceValidation = (0, exports.CardSourceSchema)(cardProvider).safeParse(cardSource);
        if (cardSourceValidation.success) {
            const validCardSource = cardSourceValidation.data;
            if (validCardSource.id &&
                state.companyCardSources?.find(source => source.id === validCardSource.id && source.name === validCardSource.name)) {
                return true;
            }
            else if (validCardSource &&
                !lodash_1.default.isEmpty(validCardSource) &&
                validCardSource.name &&
                state.companyCardSources?.find(source => source.name === validCardSource.name)) {
                errors = {
                    ...errors,
                    name: strings_1.cardDetailStrings.DUPLICATE_CARD_ERROR({ cardName: validCardSource.name }),
                };
            }
        }
        else {
            const treeifiedError = zod_1.z.treeifyError(cardSourceValidation.error);
            if (treeifiedError.properties) {
                for (const [field, issue] of Object.entries(treeifiedError.properties)) {
                    logger.warn(`${field} issue: ${issue}`);
                    errors[field] = issue.errors[0];
                }
            }
        }
        state.cardSourceSetErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const saveConfirmAside = () => {
        setPageLoading(true);
        if (!validate({
            cardSource: state.cardSource,
            cardProvider: companyPropertiesData?.cardprovider || '',
        })) {
            setPageLoading(false);
            return;
        }
        setCardName.mutate({
            cardSourceId: state.cardSource?.id || '',
            name: state.cardSource?.name || '',
        }, {
            onSuccess: () => {
                state.setNotification([{ type: strings_1.notificationStrings.SUCCESS, message: strings_1.inputStrings.SUBMIT_SUCCESS }]);
            },
            onError: () => {
                state.setNotification([{ type: strings_1.notificationStrings.WARNING, message: strings_1.inputStrings.SUBMIT_ERROR }]);
            },
            onSettled: () => {
                state.setCardSourceId('');
                toggleCardDetailsAside(false);
                setPageLoading(false);
            },
        });
    };
    const onSelectTeams = ({ id: newTeamIds }) => {
        const selectedTeams = state.cardSourceTeams?.filter(card => card.state === appConstants_1.userStatus.ACTIVE);
        const oldTeamIds = selectedTeams?.map(team => team.id);
        const teamsToBeAdded = (0, lodash_1.difference)(newTeamIds, oldTeamIds || []);
        const teamsToBeRemoved = (0, lodash_1.difference)(oldTeamIds, newTeamIds);
        setPageLoading(true);
        if (teamsToBeAdded?.length) {
            for (const teamId of teamsToBeAdded) {
                addCardSourceToTeam.mutate({ teamId, cardSourceId: state.cardSourceDetail.cardSourceId }, {
                    onSuccess: handleOnSuccess,
                    onError: handleOnError,
                    onSettled: () => setPageLoading(false),
                });
            }
        }
        if (teamsToBeRemoved?.length) {
            for (const teamId of teamsToBeRemoved) {
                removeCardSourceFromTeam.mutate({ teamId, cardSourceId: state.cardSourceDetail.cardSourceId }, {
                    onSuccess: handleOnSuccess,
                    onError: handleOnError,
                    onSettled: () => setPageLoading(false),
                });
            }
        }
        setPageLoading(false);
        state.setIsSelectTeamsOpen({ isOpen: false, model: { id: newTeamIds } });
        state.setIsCardSourceDetailOpen({ isOpen: true, cardSourceId: state.cardSourceDetail.cardSourceId });
    };
    const onRemoveCard = () => {
        try {
            removeCardSourceFromTeam.mutate({
                teamId: '',
                cardSourceId: state.cardSourceDetail.cardSourceId,
            });
            toggleCard(appConstants_1.cardDetailsAsideProperties.REMOVE_CARD, false);
            state.setNotification([
                {
                    type: strings_1.notificationStrings.SUCCESS,
                    message: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                        ? strings_1.cardDetailStrings.HSBC_REMOVE_CARD_SUCCESS
                        : strings_1.cardDetailStrings.REMOVE_CARD_SUCCESS,
                },
            ]);
        }
        catch {
            state.setNotification([
                {
                    type: strings_1.notificationStrings.WARNING,
                    message: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                        ? strings_1.errorStrings.DEFAULT
                        : strings_1.cardDetailStrings.REMOVE_CARD_ERROR,
                },
            ]);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Dialog, { open: dialog.open, onClose: () => setDialog(getInitialDialogState()), children: (0, jsx_runtime_1.jsxs)(material_1.DialogContent, { sx: { display: 'flex', flexDirection: 'column', justifyContent: 'center', minWidth: '250px', padding: 2 }, children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { display: 'flex', justifyContent: 'center' }, children: [dialog.info.type === 'SUCCESS' && ((0, jsx_runtime_1.jsx)(Check_1.default, { color: "success", fontSize: "large", style: {
                                        stroke: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'rgba(0, 132, 127, 1)' : 'rgb(80, 198, 16)',
                                        strokeWidth: 2,
                                    } })), dialog.info.type === 'WARNING' && (0, jsx_runtime_1.jsx)(Error_1.default, { color: "warning", fontSize: "large" })] }), (0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "title-info", children: dialog.info.message })] }) }), (0, jsx_runtime_1.jsx)(simpleHeader_1.default, {}), (0, jsx_runtime_1.jsx)(cards_1.default, { company: state.company, cardSource: state.cardSource, toggleCard: toggleCard, onRemoveCard: onRemoveCard, onSelectTeams: onSelectTeams, saveConfirmAside: saveConfirmAside, includeRemoveCard: includeRemoveCard, includeSelectTeams: includeSelectTeams, submitCardSourceData: submitCardSourceData, toggleCardDetailsAside: toggleCardDetailsAside, toggleAddCardSourceAside: toggleAddCardSourceAside, cardOptions: state.cardOptions || [] })] }));
};
exports.default = CompanySettingsCardsPage;
